import classNames from 'classnames';
import * as React from 'react';

import './ArrowDown24.scss';

interface ArrowDown24Props {
	isUp?: boolean;
}

const ArrowDown24: React.FC<ArrowDown24Props> = ({ isUp = false }) => {
	return (
		<svg className={classNames("arrow-down-24", { "is-arrow-upwards": isUp })} xmlns="http://www.w3.org/2000/svg" width="10" height="12" viewBox="0 0 10 12" fill="none">
			<path d="M4.74967 0C5.16379 1.24061e-05 5.49953 0.335919 5.49967 0.75V9.01953L8.23698 6.45312C8.53913 6.17001 9.01328 6.1853 9.29655 6.4873C9.5798 6.78944 9.56441 7.26356 9.26237 7.54688L5.26237 11.2969L5.14713 11.3857C4.86402 11.5631 4.48934 11.5335 4.23698 11.2969L0.236979 7.54688C-0.0650864 7.26356 -0.0804578 6.78945 0.202799 6.4873C0.486076 6.18531 0.960231 6.16999 1.26237 6.45312L3.99967 9.01953V0.75C3.99982 0.335911 4.33555 1.1232e-06 4.74967 0Z" fill="currentColor" />
		</svg>
	);
};

export default ArrowDown24;
